import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ quizTemplateId = '' }) =>
  await dponetAPI.get(
    `organization_quiz_templates/${quizTemplateId}/quiz_question_templates`,
  )

export default {
  get,
}
